export enum RootIndexMutationTypes {
  SET_CURRENT_PAGE = 'SET_CURRENT_PAGE',
  SET_NOTIFICATION = 'SET_NOTIFICATION',
  SET_BACK_ROUTER_PATH = 'SET_BACK_ROUTER_PATH',
  SET_VALIDATE = 'SET_VALIDATE',
  SET_VALID = 'SET_VALID',
  REST_SET_VALID = 'REST_SET_VALID',
}
